import { useEffect, useMemo } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import client from '../api/client';
import { trackCarFunnelStep } from '../utils/analytics';
import {
  enrichmentPathForLeadType,
  leadTypeLabel,
  markLeadEnrichmentStarted,
  parseQuoteLeadType,
  readLeadIdFromSession,
} from '../utils/leadSession';
import './CarInsuranceInformationPage.css';

function GetQuoteThankYouPage() {
  const navigate = useNavigate();
  const insuranceType = useMemo(() => {
    const stored = sessionStorage.getItem('insuranceType');
    return parseQuoteLeadType(stored) || 'car';
  }, []);

  useEffect(() => {
    const previousTitle = document.title;
    document.title = 'Thanks — we will follow up | GetSkimp';
    if (insuranceType === 'car') {
      trackCarFunnelStep('car_thank_you');
    }
    return () => {
      document.title = previousTitle;
    };
  }, [insuranceType]);

  const label = leadTypeLabel(insuranceType);
  const detailsNoun =
    insuranceType === 'pet'
      ? 'pet details'
      : insuranceType === 'home'
        ? 'home details'
        : insuranceType === 'renters'
          ? 'renters details'
          : 'car details';

  const handleContinue = () => {
    if (insuranceType === 'car') {
      trackCarFunnelStep('car_enrichment_start');
    }
    const leadId = readLeadIdFromSession();
    if (leadId) {
      markLeadEnrichmentStarted();
      void client.post(`/insurance/lead/${leadId}/enriched`).catch(() => {
        /* non-blocking */
      });
    }
    navigate(enrichmentPathForLeadType(insuranceType));
  };

  return (
    <div className="container car-thank-you-page">
      <div className="card car-thank-you-card">
        <h1 className="car-thank-you-title">Thanks — we got your info!</h1>
        <p className="car-thank-you-text">An agent will reach out to you shortly.</p>

        <div className="car-thank-you-optional">
          <h2>Have a few minutes?</h2>
          <p>
            Add your {detailsNoun} and create an account so you can get a {label.toLowerCase()} quote
            faster. Or skip and wait for our call.
          </p>
          <button type="button" className="btn btn-primary" onClick={handleContinue}>
            Add your {detailsNoun}
          </button>
        </div>

        <p className="car-thank-you-home">
          Or head back to the <Link to="/">home page</Link>.
        </p>
      </div>
    </div>
  );
}

export default GetQuoteThankYouPage;
